import React, { Component } from 'react';

import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { sanitize } from '@hotmart/devsec-toolkit';

import '../BroadcastDetail.scss';

export default class BroadcastDetailMessage extends Component {
  static propTypes = {
    message: PropTypes.string
  };

  render() {
    const { message } = this.props;
    const sanitizedHTML = sanitize({ html: message, escape: false });

    return (
      <div className="broadcast__modal">
        <h1>
          <I18n label="broadcast.modal.message.see_message" />
        </h1>
        <p>
          <I18n label="broadcast.modal.message.check_the_message_sent" />
        </p>
        <p className="message__content--active-without-bottom">
          <I18n label="broadcast.modal.message.sent_message" />
        </p>
        {message && (
          <div
            className="message__content__inner__html"
            dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
          ></div>
        )}
      </div>
    );
  }
}
